export const themes = {
  selectable: ({ isHovering }) => {
    return {
      thRoot: `bg-white text-black duration-250 ease-in transition-all ${
        isHovering ? 'border-grey' : 'border-white'
      }`,
      theNameLabel: ' text-black text-14 truncate w-full font-bold',
      theBirthdateLabel: ' text-black text-12 mb-10',
    };
  },
  selected: () => {
    return {
      thRoot: 'text-success border-success',
      theNameLabel: ' text-black text-14 truncate w-full font-bold',
      theBirthdateLabel: ' text-black text-12 mb-10',
    };
  },
  disabled: () => {
    return {
      thRoot: 'text-mediumGrey border-mediumGrey pointer-events-none',
      theNameLabel: ' text-mediumGrey text-14 truncate w-full font-bold',
      theBirthdateLabel: ' text-mediumGrey text-12 mb-10',
    };
  },
  hidden: () => {
    return {};
  },
};
